import React from "react";
import { useLocation } from "react-router-dom";
import ReactGA from "react-ga4";
import { AppLayout } from "./layout";
import { AppRoutes } from "./routes/index";
import { bootstrapAuthSession } from "./hallticket-lib";
import "./App.css";

function App() {
  const [isBootstrapping, setIsBootstrapping] = React.useState(true);
  const location = useLocation();

  React.useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: location.pathname + location.search });
  }, [location]);

  React.useEffect(() => {
    const handleGlobalClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement | null;
      if (!target) return;

      const button = target.closest("button") || target.closest(".p-button");
      if (button) {
        const label = button.getAttribute("aria-label") || button.textContent || button.getAttribute("title") || "Unknown Button";
        ReactGA.event({
          category: "Button",
          action: "Click",
          label: label.trim().substring(0, 100),
        });
      }
    };

    document.addEventListener("click", handleGlobalClick, { capture: true });
    return () => {
      document.removeEventListener("click", handleGlobalClick, { capture: true });
    };
  }, []);

  React.useEffect(() => {
    let isMounted = true;
    void bootstrapAuthSession()
      .catch(() => {
        // Leave auth as signed out if restore fails.
      })
      .finally(() => {
        if (isMounted) {
          setIsBootstrapping(false);
        }
      });

    return () => {
      isMounted = false;
    };
  }, []);

  return (
    <AppLayout>
      {isBootstrapping ? null : <AppRoutes />}
    </AppLayout>
  );
}

export default App;
